<script lang="ts">
  import { createEventDispatcher, onMount } from 'svelte';

  import Progress from '@/comps-sdk/components/progress/src/progress.svelte';

  export let isLoading = false;
  export let loadingText = '加载中~';

  const PAUSE_TIME = 70; // 进度条放缓时刻
  let percent = 0;
  const dispatch = createEventDispatcher();

  const interaction = (i: number, flag: boolean) => {
    window.requestAnimationFrame(() => {
      percent = i;
      if (i === 100) {
        dispatch('loading-done');
        return;
      }
      const next = (i === undefined ? 0 : i) + 1;
      if (next <= PAUSE_TIME || flag || !isLoading) {
        interaction(next, flag);
      } else if (next <= 99) {
        setTimeout(() => interaction(next, flag), i * 3);
      }
    });
  };

  $: {
    if (!isLoading && percent === PAUSE_TIME) {
    }
  }

  onMount(() => {
    interaction(0, false);
  });
</script>

<div class="loading-wrapper" style="height: 364px">
  <div class="loading-text">
    {loadingText}
  </div>
  <Progress percentage={percent} />
</div>

<style lang="scss">
  .loading-wrapper {
    padding: 122px 84px 0;
    .loading-text {
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: #191919;
      margin-bottom: 31px;
      text-align: center;
    }
  }
</style>
